import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from '../../context/LanguageContext';
import iconEducation from '../../assets/icons/education.png';
import iconInsurance from '../../assets/icons/insurance.png';
import iconWork from '../../assets/icons/work.png';
import { cardStagger, fadeUp, scrollViewport } from '../../motion/presets';
import './home-focus.scss';

const CARD_ORDER = [
  { id: 'courses', theme: 'education', icon: iconEducation, href: '/courses' },
  { id: 'careers', theme: 'work', icon: iconWork, href: '/careers' },
  { id: 'consultancy', theme: 'insurance', icon: iconInsurance, href: '/consultancy' },
];

const HomeFocus = () => {
  const { content } = useTranslation();
  const cards = content.home.focusCards;

  return (
    <section className="home-focus section-full home-focus--overlap" aria-labelledby="home-focus-title">
      <h2 id="home-focus-title" className="visually-hidden">
        {content.home.focusHiddenTitle}
      </h2>
      <div className="container">
        <motion.div
          className="home-focus__grid"
          variants={cardStagger}
          initial="hidden"
          whileInView="visible"
          viewport={scrollViewport}
        >
          {CARD_ORDER.map((def) => {
            const copy = cards[def.id];
            return (
              <motion.article
                key={def.id}
                id={def.id}
                className={`home-focus__card home-focus__card--${def.theme}`}
                variants={fadeUp}
              >
                <div className="home-focus__card-top">
                  <div className="home-focus__icon-wrap" aria-hidden="true">
                    <img
                      src={def.icon}
                      alt=""
                      className="home-focus__icon"
                      width={56}
                      height={56}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
                <h3 className="home-focus__card-title">{copy.title}</h3>
                <p className="home-focus__card-text">{copy.body}</p>
                <Link className="home-focus__card-link" to={def.href}>
                  {copy.linkLabel} <span aria-hidden="true">→</span>
                </Link>
              </motion.article>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default HomeFocus;
